<template>
  <div
    v-if="currentLoyaltyLevel"
    class="leading-none"
  >
    <DiscountCategoryLabel
      :category="DISCOUNT_CATEGORY.LOYALTY"
      :loyalty-level="currentLoyaltyLevel"
      is-my-account-button
    />
  </div>
</template>

<script lang="ts">


import { DISCOUNT_CATEGORY } from '~~/types/discounts';

export default defineComponent({
  name: 'MyAccountLoyaltyLevelLabel',

  setup() {

    const {
      currentLoyaltyLevel,
      loadLoyaltyLevels,
    } = useCurrentLoyaltyLevel();

    onMounted(async () => {

      await loadLoyaltyLevels();

    });

    return {
      DISCOUNT_CATEGORY,
      currentLoyaltyLevel,
    };

  },
});

</script>
